import { Api } from '@/api/api';
import { ReportQueryFilters } from '@/models/reports/report-query-filters';
import { PagedReportResult } from '@/models/reports/paged-reports-result';
import { ReportDetails } from '@/models/reports/report-details';
import { ReportDetailsViewModel } from '@/models/reports/report-details-viewmodel';
import { AttributeTreeEntry } from '@/models/reports/attribute-tree-entry';
import { QueryResult } from '@/models/reports/report-query-result';
import { SelectItem } from '@/models/reports/select-item';

export class ReportApi extends Api {
    public async fetchAsync(filters: ReportQueryFilters): Promise<PagedReportResult> {
        return await this.getAsync<PagedReportResult>('v2/report/all', filters);
    }
    public async fetchByIdAsync(id: number): Promise<ReportDetails> {
        if (id) {
            return await this.getAsync<ReportDetails>('v2/report/' + id);
        } else {
            return await this.getAsync<ReportDetails>('v2/report/');
        }
    }
    public async deleteByIdAsync(id: number): Promise<void> {
        await this.deleteAsync('v2/report/delete/' + id);
    }
    public async runAsync(reportDetails: ReportDetailsViewModel): Promise<QueryResult> {
        return await this.postAsync<QueryResult>('v2/report/run/', reportDetails);
    }
    public async downloadAsync(reportDetails: ReportDetailsViewModel): Promise<any> {
        return await this.getFileFromPostAsync('v2/report/download/', reportDetails);
    }
    public async saveAsync(reportDetails: ReportDetailsViewModel): Promise<any> {
        return await this.postAsync('v2/report', reportDetails);
    }

    public async fetchEntitiesBySearchTerm(searchTerm: string, foreignKeyTable: string): Promise<Array<SelectItem>> {
        const results = await this.postAsync<Array<SelectItem>>('v2/report/entities', { searchTerm, entityTypeName: foreignKeyTable });
        return results;
    }

    public async getSelectorsAsync(): Promise<Array<AttributeTreeEntry>> {
        return await this.getAsync<Array<AttributeTreeEntry>>('v2/report/selectors');
    }
}
